import { createHeaderCell } from '../../../../../../../../../../../../../../utils/tableUtil';

import CheckboxCell from './cells/CheckboxCell';
import ExpirationDateCell from './cells/ExpirationDateCell';

export const validResourceTypes = { documents: 'documents' };

export const ColumnTypes = {
  Checkboxes: 'Checkboxes',
  PolicyType: 'Policy Type',
  PolicyNumber: 'Policy Number',
  ExpirationDate: 'Expiration Date',
  Status: 'Status'
};

export const ColumnTypeCells = {
  [ColumnTypes.Checkboxes]: {
    accessor: 'id',
    Cell: CheckboxCell,
    disableSortBy: true,
    colSpan: 1
  },
  [ColumnTypes.PolicyType]: {
    Header: createHeaderCell(ColumnTypes.PolicyType),
    accessor: 'insurancePolicyType.displayName',
    colSpan: 1
  },
  [ColumnTypes.PolicyNumber]: {
    Header: createHeaderCell(ColumnTypes.PolicyNumber),
    accessor: 'number',
    colSpan: 1
  },
  [ColumnTypes.ExpirationDate]: {
    Header: createHeaderCell(ColumnTypes.ExpirationDate),
    Cell: ExpirationDateCell,
    accessor: 'expiresAt',
    colSpan: 1
  }
};

export const Columns = [
  ColumnTypes.Checkboxes,
  ColumnTypes.PolicyType,
  ColumnTypes.PolicyNumber,
  ColumnTypes.ExpirationDate
];
